export default "__VITE_ASSET__gNt0ynIo__"